module.exports = __webpack_public_path__ + "static/media/donate_2226736.e7600fa7.svg";